const MetaFactsPhoneIcon = ({ width = "12", height = "12" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 13 12"
    fill="none"
  >
    <path
      d="M4.36484 0.576603C4.18437 0.140665 3.70859 -0.0913661 3.25391 0.0328527L1.19141 0.595353C0.783594 0.707853 0.5 1.07817 0.5 1.50004C0.5 7.29848 5.20156 12 11 12C11.4219 12 11.7922 11.7164 11.9047 11.3086L12.4672 9.24613C12.5914 8.79145 12.3594 8.31567 11.9234 8.1352L9.67344 7.1977C9.29141 7.03832 8.84844 7.14848 8.58828 7.46957L7.64141 8.62504C5.99141 7.84457 4.65547 6.50863 3.875 4.85863L5.03047 3.9141C5.35156 3.6516 5.46172 3.21098 5.30234 2.82895L4.36484 0.578946V0.576603Z"
      fill="#3F83F8"
    />
  </svg>
);

export default MetaFactsPhoneIcon;
